<template>
    <CModal
      title="Ejemplo Comprobante de Pago"
      :color="color"
      :show.sync="documentExampleModal"
    >   
        <CRow>
          <CCol md="12" >
              <img :src="exampleSrc" alt="Ejemplo de comprobante" style="width: 100%; height: auto;" />
          </CCol>
        </CRow>
        <template #footer>
          <CButton  @click="closeModal" color="secondary" style="float: right;">Cerrar</CButton>
        </template>
    </CModal>
</template>

<script>

export default {
  name: 'DocumentExampleModal',
  props: {
  },
  data () {
    return {
      documentExampleModal: false,
      title: "Comprobante de Pago",
      color: "info",
      exampleSrc: 'payment_receipt_example.jpg'
    }
  },
  mounted: async function() {
    
  },
  methods: {
    openModal () {
      this.documentExampleModal = true;
      this.color = "info";
      this.title = 'Comprobante de Pago';      
    },
    closeModal () {
      this.documentExampleModal = false;
    },
  }
}
</script>